module.exports = __webpack_public_path__ + "images/266f7e99f496c2f2325545f419744006.png";


//////////////////
// WEBPACK FOOTER
// ./js/components/assets/man/4.png
// module id = 364
// module chunks = 0